import React from "react";

import Navbar from "../components/Navbar/Navbar";
import CookieSettings from "../components/Cookies/CookieSettings";
import Footer from "../sections/Footer/Footer";

const CookieEinstellungen = () => {
    return (
        <>
            <Navbar />

            <CookieSettings />

            <Footer />
        </>
    );
};

export default CookieEinstellungen;